// ============================================
// MÓDULO AUTH — ÁRVORE PÚBLICA (não exige conta logada)
// Fluxo de entrada (login, recuperação de senha, primeiro acesso, ...) +
// públicas abertas (SKILL_EXPLORER_CATALOG, CB_UNICO_SUCCESS), estas acessíveis
// por qualquer um, logado ou não. Ver ../README.md e ./routes.tsx.
// ============================================

export const AUTH_ROUTES = {
  LOGIN: {
    value: '/login',
    name: 'login',
    title: 'Login'
  },
  LOGOUT: {
    value: '/logout',
    name: 'logout',
    title: 'Logout'
  },
  FORGOT_PASSWORD: {
    value: '/forgot-password',
    name: 'forgot_password',
    title: 'Recuperar Senha'
  },
  RESET_PASSWORD: {
    value: '/reset-password',
    name: 'reset_password',
    title: 'Redefinir Senha'
  },
  RESEND_ACCESS: {
    value: '/resend-access',
    name: 'resend_access',
    title: 'Reenviar Acesso'
  },
  CB_UNICO_SUCCESS: {
    value: '/cbu/success',
    name: 'cbu_success'
  },
  FIRST_ACCESS: {
    value: '/first-access',
    name: 'first_access'
  },
  FIRST_ACCESS_CPF: {
    value: '/first-access/cpf',
    name: 'first_access_cpf'
  },
  SKILL_EXPLORER_CATALOG: {
    value: '/skill-explorer-catalog',
    name: 'skill_explorer_catalog'
  },
  LOGIN_FIRST_ACCESS: {
    value: '/login-first-access',
    name: 'login_first_access'
  }
} as const
